//La lunghezza va da 1 a 100 puoi inserire anche degli spazi
export const nameRegex = /^(?=.{1,99}$)[a-z ,.'-]+$/i

//La lunghezza massima della mail è di 254
export const emailRegex = /^(?=.{1,253}$)\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/

export const subjectRegex = nameRegex
